module.exports = __webpack_public_path__ + "static/media/fair.7ffd78f0.jpg";